"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpTag = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DpTag_styled_1 = require("./DpTag.styled");
var DpTag = function (_a) {
    var children = _a.children, _b = _a.transformation, transformation = _b === void 0 ? 'uppercase' : _b;
    return ((0, jsx_runtime_1.jsx)(DpTag_styled_1.StyledTag, { texttransformation: transformation, children: children }));
};
exports.DpTag = DpTag;
exports.default = exports.DpTag;
